import { FC } from 'react';

type Props = {
	className?: string;
};

const StatusSuspendedIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#EAEAEA'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.33301 10.0001C2.33301 5.58176 5.91477 2 10.3331 2C14.7514 2 18.3332 5.58176 18.3332 10.0001C18.3332 14.4184 14.7514 18.0002 10.3331 18.0002C5.91477 18.0002 2.33301 14.4184 2.33301 10.0001ZM9.5889 12.9769C9.5889 12.5658 9.92058 12.2327 10.3297 12.2327H10.3364C10.7456 12.2327 11.0773 12.5658 11.0773 12.9769C11.0773 13.3879 10.7456 13.721 10.3364 13.721H10.3297C9.92058 13.721 9.5889 13.3879 9.5889 12.9769ZM9.5889 10.0001C9.5889 10.4111 9.92207 10.7443 10.3331 10.7443C10.7441 10.7443 11.0773 10.4111 11.0773 10.0001V7.02331C11.0773 6.6123 10.7441 6.27911 10.3331 6.27911C9.92207 6.27911 9.5889 6.6123 9.5889 7.02331V10.0001Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default StatusSuspendedIcon;
